import { render, staticRenderFns } from "./EnterNewTrade.vue?vue&type=template&id=a1c0aa7e&scoped=true&"
import script from "./EnterNewTrade.vue?vue&type=script&lang=js&"
export * from "./EnterNewTrade.vue?vue&type=script&lang=js&"
import style0 from "./EnterNewTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EnterNewTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./EnterNewTrade.vue?vue&type=style&index=2&id=a1c0aa7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0aa7e",
  null
  
)

export default component.exports